export default {
      id: "refresh-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#refresh",
      toString: function () {
        return this.url;
      }
    }